/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Add_TriggerInputs */

const cs_automation_add_trigger = /** @type {(inputs: Automation_Add_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat trigger`)
};

const en_automation_add_trigger = /** @type {(inputs: Automation_Add_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add trigger`)
};

/**
* | output |
* | --- |
* | "Add trigger" |
*
* @param {Automation_Add_TriggerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_add_trigger = /** @type {((inputs?: Automation_Add_TriggerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Add_TriggerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_add_trigger(inputs)
	return cs_automation_add_trigger(inputs)
});